import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const CategoryGrid = () => {
  const categories = [
    { id: 1, name: 'Fresh Vegetables', image: 'https://images.unsplash.com/photo-1566385101042-1a0aa0c1268c?w=400', color: '#22c55e', count: '120+' },
    { id: 2, name: 'Tea & Coffee', image: 'https://images.unsplash.com/photo-1544787219-7f47ccb76574?w=400', color: '#f59e0b', count: '45+' },
    { id: 3, name: 'Cooking Oils', image: 'https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?w=400', color: '#ef4444', count: '30+' },
    { id: 4, name: 'Flour & Atta', image: 'https://images.unsplash.com/photo-1627485937980-221c88ac04f9?w=400', color: '#d97706', count: '25+' },
    { id: 5, name: 'Rice Varieties', image: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=400', color: '#eab308', count: '50+' },
    { id: 6, name: 'Spices & Masala', image: 'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?w=400', color: '#dc2626', count: '200+' },
    { id: 7, name: 'Pooja Items', image: 'https://images.unsplash.com/photo-1606293926075-69a00febf780?w=400', color: '#f97316', count: '80+' },
    { id: 8, name: 'Snacks & Sweets', image: 'https://images.unsplash.com/photo-1599490659213-e2b9527bd087?w=400', color: '#8b5cf6', count: '150+' },
  ];

  return (
    <section id="categories" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="text-primary-600 font-semibold text-sm uppercase tracking-wider">Explore</span>
          <h2 className="text-4xl font-bold text-gray-900 mt-2">Shop by Category</h2>
          <p className="text-gray-500 mt-4 max-w-2xl mx-auto">
            Browse through our wide selection of authentic Indian groceries, fresh produce, and daily essentials.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {categories.map((cat, index) => (
            <motion.div
              key={cat.id}
              className="group relative overflow-hidden rounded-2xl cursor-pointer shadow-sm hover:shadow-xl transition-shadow duration-300"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ delay: index * 0.05 }}
              whileHover={{ y: -8 }}
            >
              <Link to={`/shop?category=${cat.id}`}>
                <div className="aspect-[4/5] overflow-hidden relative">
                  <motion.img
                    src={cat.image}
                    alt={cat.name}
                    className="w-full h-full object-cover"
                    whileHover={{ scale: 1.1 }}
                    transition={{ duration: 0.6 }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />

                  {/* Color accent bar */}
                  <div
                    className="absolute top-0 left-0 right-0 h-1"
                    style={{ backgroundColor: cat.color }}
                  />
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="text-white font-bold text-lg">{cat.name}</h3>
                      <p className="text-white/70 text-sm">{cat.count} Products</p>
                    </div>
                    <motion.div
                      className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center"
                      whileHover={{ scale: 1.2, backgroundColor: 'rgba(255,255,255,0.4)' }}
                    >
                      <ArrowRight size={18} className="text-white" />
                    </motion.div>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryGrid;
